// extracted by mini-css-extract-plugin
export default {"wrapperDefaultGame":"DefaultGameImg_wrapperDefaultGame__PvGep","img":"DefaultGameImg_img__dd8cr","gameName":"DefaultGameImg_gameName__DRK81"};